import { __decorate, __param, __metadata } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Inject, EventEmitter, Input, Output, ViewChild, Component, NgModule } from '@angular/core';
import { DatePickerComponent, DpDatePickerModule } from 'ng2-date-picker';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCDatePickerService = class UiCDatePickerService {
    constructor(config) {
        this.config = config;
    }
};
UiCDatePickerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCDatePickerService_Factory() { return new UiCDatePickerService(ɵɵinject("config")); }, token: UiCDatePickerService, providedIn: "root" });
UiCDatePickerService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __param(0, Inject('config')),
    __metadata("design:paramtypes", [Object])
], UiCDatePickerService);

let UiCDatePickerComponent = class UiCDatePickerComponent {
    constructor(service) {
        this.service = service;
        this.showIcon = false;
        this.dateSelected = new EventEmitter();
        this.onLeftNavData = new EventEmitter();
        this.onRightNavData = new EventEmitter();
        // checa o environment
        this.controlEnv = 'app';
    }
    ngOnInit() {
        this.initialConfig();
    }
    initialConfig() {
        if (this.service.config.environment !== undefined || this.service.config.environment !== null) {
            this.controlEnv = this.service.config.environment;
        }
        this.configDataDefault = {
            format: 'DD/MM/YYYY',
            editable: false,
        };
        if (this.datePickerConfig)
            this.datePickerConfig = this.datePickerConfig;
        else
            this.datePickerConfig = this.configDataDefault;
    }
    dateChanged(e) {
        this.dateSelected.emit(e.detail.value);
    }
    /**
     * quando seleciona uma data do calendario
     */
    calDaySelected() {
        this.dateSelected.emit(this.selectedDate);
    }
    open() {
        this.datePicker.api.open();
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDatePickerComponent.prototype, "inputValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDatePickerComponent.prototype, "selectedDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDatePickerComponent.prototype, "datePickerConfig", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDatePickerComponent.prototype, "showIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCDatePickerComponent.prototype, "formDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDatePickerComponent.prototype, "formName", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDatePickerComponent.prototype, "dateSelected", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDatePickerComponent.prototype, "onLeftNavData", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDatePickerComponent.prototype, "onRightNavData", void 0);
__decorate([
    ViewChild('dayPicker', null),
    __metadata("design:type", DatePickerComponent)
], UiCDatePickerComponent.prototype, "datePicker", void 0);
UiCDatePickerComponent = __decorate([
    Component({
        selector: 'ui-c-date-picker',
        template: "<div [ngSwitch]=\"controlEnv\">\n  <!-- display mobile -->\n  <ion-item *ngSwitchCase=\"'app'\" lines=\"none\">\n    <ion-label>{{ inputValue }}</ion-label>\n    <ion-datetime mode=\"ios\" [(ngModel)]=\"selectedDate\" (ionChange)=\"dateChanged($event)\"\n      cancelText=\"{{ 'DATE_PICKER.CANCEL_BUTTON' | wlpTranslate }}\"\n      doneText=\"{{ 'DATE_PICKER.CONFIRM_BUTTON' | wlpTranslate }}\" displayFormat=\"DD/MM/YYYY\">\n    </ion-datetime>\n  </ion-item>\n  \n  <!-- display web -->\n  <div *ngSwitchCase=\"'web'\" class=\"cal-holder-position\">\n    <ng-container *ngIf=\"!formDate\">\n      <dp-date-picker\n        #dayPicker\n        theme=\"dp-material\"\n        [placeholder]=\"inputValue\"\n        [(ngModel)]=\"selectedDate\"\n        [config]=\"datePickerConfig\"\n        (onChange)=\"calDaySelected()\">\n      </dp-date-picker>\n    </ng-container>\n\n    <ng-container *ngIf=\"formDate\">\n      <form [formGroup]=\"formDate\">\n        <dp-date-picker \n          dayPicker \n          theme=\"dp-material\" \n          [placeholder]=\"inputValue\" \n          [formControlName]=\"formName\"\n          [(ngModel)]=\"selectedDate\" \n          [config]=\"datePickerConfig\" \n          (onChange)=\"calDaySelected()\">\n    </dp-date-picker>\n      </form>\n    </ng-container>\n    <ng-container *ngIf=\"showIcon\">\n      <ion-icon name=\"calendar-outline\" class=\"font-size-18 pl-1\" (click)=\"open()\"></ion-icon>\n    </ng-container>\n  </div> \n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [UiCDatePickerService])
], UiCDatePickerComponent);

var UiCDatePickerModule_1;
let UiCDatePickerModule = UiCDatePickerModule_1 = class UiCDatePickerModule {
    static forRoot(config) {
        return {
            ngModule: UiCDatePickerModule_1,
            providers: [
                UiCDatePickerService,
                {
                    provide: 'config',
                    useValue: config
                }
            ]
        };
    }
};
UiCDatePickerModule = UiCDatePickerModule_1 = __decorate([
    NgModule({
        declarations: [UiCDatePickerComponent],
        imports: [
            IonicModule,
            CommonModule,
            FormsModule,
            DpDatePickerModule,
            UiBsTranslateModule,
            ReactiveFormsModule
        ],
        providers: [UiCDatePickerService],
        exports: [UiCDatePickerComponent]
    })
], UiCDatePickerModule);

export { UiCDatePickerComponent, UiCDatePickerModule, UiCDatePickerService };
//# sourceMappingURL=wlp-ui-c-date-picker.js.map
